import { Grid2, List, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import { ScrollContainerWithHeader } from '../../shared/components/student/ScrollComponent'
import EventBookingCard from '../../shared/components/student/EventBookingCard'
import BookedEvent from '../../shared/components/student/BookedEvent'
import { NormalContainerWithHeader } from '../../shared/components/student/NormalComponent'
import { useCourses, useEvents, useStudentBookEventList } from '../../assets/api/UseStudentGetApi'
import { SkeletonCom } from '../../shared/utils/SkeletonCom'
import { Constants, Grid_Gap } from '../../shared/constants'
import { GridChildren } from '../../shared/utils/LingtBlueContainer'
import { useAutoPaginatedQuery } from '../../shared/hook/useAutoPaginatedQuery'
import PlaceholderImg from '../../shared/components/PlaceholderImg'
import { useProcessedCourses } from '../../shared/hook/useProcessedCourses'

const EventSection = () => {
  const { data, fetchNextPage, hasNextPage, isLoading } = useEvents();
  useEffect(() => {
    if (hasNextPage) {
      fetchNextPage();
    }
  }, [hasNextPage, fetchNextPage]);
  const events = data?.pages.flatMap(page => page.data) || [];
  const { data: bookEventList, isLoading: isLoadingEventList } = useStudentBookEventList();
  
  // const {
  //   items: courses,
  //   isLoading: isEventCourseLoading,
  // } = useAutoPaginatedQuery(useCourses());

  const { page: courses, isLoading:isEventCourseLoading } = useProcessedCourses()
  const typeFiveCourses = courses?.filter(item => item?.type === 5);


  return (
    <Grid2 container spacing={Grid_Gap}>
      <Grid2 item size={{ xs: 12, lg: 8, }} >
        <ScrollContainerWithHeader headerText={"Event Booking"}>
          {
            !isEventCourseLoading && (
              typeFiveCourses?.map((item, index) => (
                <Grid2
                  key={index}
                  size={{ xs: 10, sm: 5, lg: 5 }}
                  sx={{ flex: '0 0 auto', display: "flex", alignItems: "stretch" }}
                >
                  <EventBookingCard item={item} />
                </Grid2>

              ))
            )
          }

          {
            isEventCourseLoading && (
              [...Array(4)].map((_, index) => (
                <GridChildren sx={{ flex: '0 0 auto' }} index={index} key={index}>
                  <SkeletonCom height={"320px"} />
                </GridChildren>
              ))
            )
          }
        </ScrollContainerWithHeader>
      </Grid2>
      <Grid2 item size={{ xs: 12, lg: 4, }}>
        <NormalContainerWithHeader headerText={"Booked Events"}>


          <List>


            {!isLoadingEventList && (
              bookEventList?.data?.length > 0 ? (
                bookEventList.data.map((item, index) => (
                  <BookedEvent key={item.event_id || index} item={item} />
                ))
              ) : (
            //  <Typography variant='body1'>
            //       You have not booked any event yet.
            // </Typography>
            <PlaceholderImg img={Constants.customImages.BookedEventPlaceholder} text={"You have not booked any event yet."}/>
              )
            )}

            {isLoadingEventList && (
              [...Array(5)].map((_, index) => (
                <SkeletonCom key={index} height="60px" style={{ margin: "10px 0" }} />
              ))
            )}


          </List>
        </NormalContainerWithHeader>
      </Grid2>
    </Grid2>
  )
}

export default EventSection